import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui's class merger — clsx for conditionals, tailwind-merge to let a
 *  caller's className win over a component's defaults instead of both landing
 *  in the class list and the cascade picking arbitrarily. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
